export default "__VITE_ASSET__aa2f9d9c__"